export default __webpack_public_path__ + "static/media/2a001.5ac633a8.jpg";